var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(() => _vm.callAction(_vm.event)),expression:"() => callAction(event)"}],staticClass:"o-typography__label o-button__label"},[_vm._v(" "+_vm._s(_vm.event.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }